(() => {
  function init() {
    const root = document.querySelector('[data-k4y-focus]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const fields = ['temperature', 'power', 'length', 'width', 'height', 'insulation', 'goods', 'loading', 'opening', 'ambient'];
    function refreshContext() {
      const params = new URLSearchParams(location.search);
      const context = fields.filter(key => params.has(`k4y_${key}`)).map(key => `${root.dataset[`context${key[0].toUpperCase()}${key.slice(1)}`]}: ${params.get(`k4y_${key}`).slice(0, 150)}`);
      if (params.has('f.kaeltemittel')) context.push(`Kältemittel: ${params.get('f.kaeltemittel').slice(0, 150)}`);
      const text = context.join(' · ');
      const values = root.querySelector('[data-k4y-context-values]');
      if (values) values.textContent = text;
      const box = root.querySelector('[data-k4y-context]');
      if (box) box.hidden = !fields.some(key => params.has(`k4y_${key}`));
      const note = root.querySelector('[data-k4y-selection-explanation]');
      if (note) note.hidden = !params.has('k4y_power');
      const contact = document.querySelector('[data-k4y-contact-context]');
      if (contact) contact.value = text;
      const technical = document.getElementById('K4YTech');
      if (technical && !technical.value.trim()) technical.value = text;
    }
    refreshContext();
    document.addEventListener('k4y:selection-change', refreshContext);
    document.querySelectorAll('.k4y-subcategories').forEach(nav => {
      const track = nav.querySelector('[data-k4y-category-track]');
      nav.querySelector('[data-k4y-category-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
      nav.querySelector('[data-k4y-category-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    });
    const form = document.getElementById('K4YAdviceForm');
    if (form) form.addEventListener('submit', () => {
      try {
        const selected = JSON.parse(localStorage.getItem('compareList') || '[]');
        const input = form.querySelector('[data-k4y-contact-compare]');
        if (input && Array.isArray(selected)) input.value = selected.slice(0, 8).map(product => product.title || product.handle || '').filter(Boolean).join(' | ');
      } catch (_) {}
    });
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-k4y-inquire-product]');
      if (!link) return;
      const model = document.getElementById('K4YModel');
      const question = document.getElementById('K4YQuestion');
      if (model) model.value = link.dataset.k4yInquireProduct;
      if (question && !question.value.trim()) question.value = 'Bitte senden Sie mir das passende Produktdatenblatt.';
    });
    if (location.hash === '#K4YAdviceForm' && form) {
      requestAnimationFrame(() => {
        form.scrollIntoView({ block: 'start' });
        form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
